import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { generateBlockLibraryCollectionListParams } from '@features/filter/static/filterUtil';

import { clearFilterResponse, handleFilter } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchDependentFilterList } from '@services/commonService';

import { getCollectionTimeCount, isPageReachBottom } from '@utils/Util';

const CollectionViewItems = ({ setTotalElements }) => {
	const dispatch = useDispatch();
	const [collectionList, setCollectionList] = useState(null);
	const filterResponse = useSelector((store) => store.filterResponseStore);
	let filterfields = useSelector((store) => store.filterFieldStore);
	const [page, setPage] = useState(0);
	const sortValue = filterfields['sort'] && filterfields['sort'][0]?.key;
	const scrollRef = useRef({});
	const navigate = useNavigate();
	const paramsData = generateBlockLibraryCollectionListParams(filterfields, 0, sortValue);

	const setCurrentState = (data) => {
		scrollRef.current = data;
	};

	useEffect(() => {
		setCurrentState(filterResponse);
		setCollectionList(filterResponse);
	}, [filterResponse]);

	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(openLoader());
		dispatch(fetchDependentFilterList({ type: 'BLOCK_LIBRARY_COLLECTION_VIEW_LIST' }, paramsData));
		let queryParams = generateBlockLibraryCollectionListParams(filterfields, 0, sortValue);
		dispatch(handleFilter('getCollectionList', queryParams, false)).finally(() => {
			dispatch(closeLoader());
		});
	}, [filterfields]);

	useEffect(() => {
		if (page !== 0) {
			dispatch(openLoader());
			let queryParams = generateBlockLibraryCollectionListParams(filterfields, page, sortValue);
			dispatch(handleFilter('getCollectionList', queryParams, true)).finally(() => {
				dispatch(closeLoader());
			});
		}
	}, [page]);

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			dispatch(clearFilterResponse());
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { totalElements, currentPage, data } = scrollRef.current;
			if (totalElements !== data?.length) {
				setPage(() => currentPage + 1);
			}
		}
	};

	useEffect(() => {
		if (collectionList) {
			setTotalElements(collectionList.totalElements);
		}
	}, [collectionList, setTotalElements]);

	const renderDesign = () => {
		return collectionList?.data?.map((item) => {
			return (
				<div
					onClick={() => {
						navigate(`/collections/view/${item?.id}?requestFrom=blockLibrary`);
					}}
					className="single-collection-item"
					key={`costing_item_${item.id}`}
				>
					<div className="product-img-container">
						<div className="prev-img">
							{item?.documentPathList && item?.documentPathList[0] ? (
								<img src={item?.documentPathList[0]} alt="" />
							) : (
								<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
							)}
						</div>
						<div className="prev-img-thumb">
							<div className="single-first">
								{item?.documentPathList && item?.documentPathList[1] ? (
									<img src={item?.documentPathList[1]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
							<div className="single-second">
								{item?.documentPathList && item?.documentPathList[2] ? (
									<img src={item?.documentPathList[2]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
						</div>
					</div>
					<div className="design-details d-flex justify-content-between">
						<div className="design-details d-flex justify-content-between">
							<div className="details">
								<p className="collection-title regular-12 mb-0 gray_dark_01 weight-500">
									{item?.title || item?.collectionName}
								</p>
								<ul className="common-list-component mt-1">
									<li>
										<span className="name gray_dark_02">{item?.ownerName}</span>
									</li>
									<li>
										<span className="weight-300 gray_dark_01">{item?.brand}</span>
									</li>
									<li>{getCollectionTimeCount(item?.dateCreated)}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="designs-collections-container pl-2 bg-white">
			<div className="collections-row"> {renderDesign()} </div>
		</div>
	);
};

export default CollectionViewItems;
